import { render, staticRenderFns } from "./SkuDatatable.vue?vue&type=template&id=b90a8812"
import script from "./SkuDatatable.vue?vue&type=script&lang=js"
export * from "./SkuDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports